import React from 'react';
import { format } from 'date-fns';

/**
 * Tells staff their typing is protected without making them wonder. Sits next
 * to the Save button on every encoding grid.
 *
 * Says nothing at all when there is no draft — an empty screen claiming
 * "nothing to save" is noise, and a stale "Draft saved" line after a successful
 * submit would be a lie.
 */
const DraftStatusIndicator = ({ lastSavedAt, isSaving }) => {
  if (isSaving) {
    return (
      <span className="text-xs text-ink-body" role="status">
        Saving draft…
      </span>
    );
  }

  if (!lastSavedAt) return null;

  return (
    <span className="text-xs text-ink-body" role="status">
      Draft autosaved{' '}
      <span className="tabular-nums">{format(new Date(lastSavedAt), 'h:mm a')}</span>
      <span className="text-ink-body/70"> · this browser only</span>
    </span>
  );
};

export default DraftStatusIndicator;
